import { ReactElement } from 'react'

import { TeamOutlined } from '@ant-design/icons'
import { Typography } from 'antd'

import { Flex } from 'components/core'
import { theme } from 'styles/theme'

import { SerializableOrgGroup } from './serializableOrgGroup'
import * as styles from './styles.scss'

const { Text } = Typography

interface Props {
    serializable: SerializableOrgGroup
    showOrg?: boolean
}

const SerializableOrgGroupDisplay = ({
    serializable,
    showOrg = true,
}: Props): ReactElement => {
    const { orgId, label } = serializable

    const finalLabel = showOrg ? label : (label ?? '').split('|').pop()

    return (
        <Flex gap={8} className={styles.display}>
            <>
                <div
                    style={{
                        width: 32,
                        textAlign: 'right',
                    }}
                >
                    <Text
                        style={{
                            color: theme.colors.textLight,
                            fontWeight: theme.fontWeight.light,
                        }}
                    >
                        {showOrg ? orgId : <TeamOutlined />}
                    </Text>
                </div>
                <span style={{ color: theme.colors.textExtraLight }}>|</span>
            </>

            <Flex style={{ flex: 1 }}>
                <Text className={styles.label}>{finalLabel}</Text>
            </Flex>
        </Flex>
    )
}

export default SerializableOrgGroupDisplay
